import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    List,
    ListItem,
} from "@mui/material";
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import { ViewContext } from "components/lib";
import { useContext } from "react";

/**
 * Reusable Report Creation Dialogue
 * @param {boolean} open - Controls dialog visibility
 * @param {function} onSave - Called when user clicks Proceed
 * @param {function} onClose - Called when user clicks Cancel or closes dialog
 */
export const ReportDialogue = ({ open, onSave, onClose }) => {
    const viewContext = useContext(ViewContext);
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{viewContext.t('Components.ReportDialogue.dialogue.title')}</DialogTitle>
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    {viewContext.t('Components.ReportDialogue.dialogue.body1')}<strong>{viewContext.t('Components.ReportDialogue.dialogue.body2')}</strong>.
                </Typography>
                <Typography variant="body2" sx={{ mt: 1 }}>
                    {viewContext.t('Components.ReportDialogue.dialogue.paraTitle')}
                </Typography>
                <List dense>
                    <ListItem>{viewContext.t('Components.ReportDialogue.dialogue.step1')}<a style={{ color: '#1450a0' }} href="https://platform.openai.com/api-keys" target="_blank" rel="noopener noreferrer"> {viewContext.t('Components.ReportDialogue.dialogue.link')}</a>.</ListItem>
                    <ListItem>{viewContext.t('Components.ReportDialogue.dialogue.step2')}</ListItem>
                    <ListItem>{viewContext.t('Components.ReportDialogue.dialogue.step3')}<strong>{viewContext.t('Components.ReportDialogue.dialogue.step3Bold')}</strong>.</ListItem>
                    <ListItem>{viewContext.t('Components.ReportDialogue.dialogue.step4')}</ListItem>
                </List>
                <Typography variant="body2" sx={{ mt: 1 }}>
                    {viewContext.t('Components.ReportDialogue.dialogue.footer1')} <strong>{viewContext.t('Components.ReportDialogue.dialogue.footerBold')}</strong> {viewContext.t('Components.ReportDialogue.dialogue.footer2')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <AivagamButton
                    id="cancelDialogue"
                    buttonText={viewContext.t('Components.ReportDialogue.dialogue.cancelButton')}
                    classStyles={{ width: '8em' }}
                    onClick={onClose}
                    type="cancel"
                />
                <AivagamButton
                    id="confirmDialogue"
                    buttonText={viewContext.t('Components.ReportDialogue.dialogue.proceed')}
                    classStyles={{ width: '8em' }}
                    onClick={onSave}
                    type="confirm"
                />
            </DialogActions>
        </Dialog>
    );
};
